import {
  GROUP_BASIC,
  GROUP_LOOP_MERGE,
  GROUP_AB_TEST,
  GROUP_CONJOINT,
  GROUP_VAN_WESTENDORP,
  GROUP_MAXDIFF,
} from 'data/nodeTypes';
import messages from './messages';

export const groupMessages = {
  [GROUP_BASIC]: messages.group,
  [GROUP_LOOP_MERGE]: messages.group,
  [GROUP_AB_TEST]: messages.abtest,
  [GROUP_CONJOINT]: messages.conjoint,
  [GROUP_VAN_WESTENDORP]: messages.vanWestendorpShort,
  [GROUP_MAXDIFF]: messages.maxDiff,
};

export const LOOP_AND_MERGE_ATTRIBUTE_TYPE = 'MergeQuestion';
